String.prototype.endsWith = function (str) {
    /// <summary>String extension method to check if a string ends with another string</summary>
    /// <param name="str" type="String">The string to check</param>
    /// <returns type="Boolean">True if the string ends with the string to check for</returns>

    if (!str || str.length > this.length) return false;
    var end = this.length, start = end - str.length;
    return this.substring(start, end) == str;
}

String.prototype.format = function () {
    /// <summary>String extension method to format a string, unlimited number of format parameters</summary>
    /// <returns type="String">The formatted string</returns>

    if (arguments.length) {
        var retStr = this;
        var args = arguments;
        if (isArray(args[0])) {
            args = args[0];
        }
        for (var i = 0; i < args.length; i++) {
            var param = '\\{' + i + '\\}';
            var reg = new RegExp(param, 'g');
            retStr = retStr.replace(reg, args[i]);
        }
        return retStr;
    }
    else {
        return this;
    }
}

String.prototype.dataFormat = function (data) {
    /// <summary>Formats data into a string. Field names should be inserted like [FirstName] etc</summary>
    /// <param name="formatString" type="String">The format string</summary>
    /// <param name="data" type="Object">The data object</summary>
    /// <returns type="Strung">Returns the formatted data string</returns>

    var formatString = this;
    if (!formatString) return '';
    if (formatString.indexOf('[') == -1 || formatString.indexOf(']') == -1) return formatString;

    var outputString = formatString;
    formatString.match(/\[(.*?)\]/g).forEach(function (val) {

        var field = val.replace(/\[/g, '').replace(/\]/, ''),
        value = cafm.util.getReference(field, data);
        outputString = outputString.replace(val, value ? value : '');
    });

    return outputString;
}

String.prototype.routeFormat = function (args) {
    /// <summary>Formats a route into a path string. Route parameter names should be inserted like {id} etc</summary>
    /// <param name="args" type="Object">The route handler args</summary>
    /// <returns type="Strung">Returns the formatted route path string</returns>

    var formatString = this;
    if (!formatString) return '';
    if (formatString.indexOf('{') == -1 || formatString.indexOf('}') == -1) return formatString;

    var outputString = formatString;
    formatString.match(/{(.*?)}/g).forEach(function (val) {

        var field = val.replace(/{/g, '').replace(/}/, ''),
            value = cafm.util.getReference(field, args);
        outputString = outputString.replace(val, value ? value : '');
    });

    return outputString;
}

String.prototype.startsWith = function (str) {
    /// <summary>String extension method to check if a string starts with another string</summary>
    /// <param name="str" type="String">The string to check</param>
    /// <returns type="Boolean">True if the string starts with the string to check for</returns>
    
    return this.indexOf(str) == 0;
}

JSON.safeParse = function (s) {
    /// <summary>Wraps JSON.parse with a try catch, if the parse fails the input parameter is passed back</summary>
    /// <param name="s" type="Object">The json string to parse</param>
    /// <returns type="Object">The parsed JSON object</returns>

    try {
        return JSON.parse(s);
    }
    catch (e) {
        return s;
    }
}

window.isUndefined = function (o) {
    /// <summary>Determines if an object is undefined</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is undefined</returns>

    return typeof (o) == 'undefined' || o == 'undefined';
}
window.isDefined = function (o) {
    /// <summary>Determines if an object is defined</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is defined</returns>

    return typeof (o) != 'undefined';
}
window.isNullOrUndefined = function (o) {
    /// <summary>Determines if an object is undefined or null</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is undefined or null</returns>

    return typeof (o) == 'undefined' || o == 'undefined' || o == null;
}
window.isFunc = function (o) {
    /// <summary>Determines if an object is a function</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is a function</returns>

    return typeof (o) == 'function';
}
window.isObj = function (o) {
    /// <summary>Determines if an object reference is of the type 'object'</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is of the type 'object'</returns>

    return typeof (o) == 'object';
}
window.isStr = function (o) {
    /// <summary>Determines if an object reference is of the type 'string'</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is of the type 'string'</returns>

    return typeof (o) == 'string';
}
window.isNum = function (o) {
    /// <summary>Determines if an object reference is of the type 'number'</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is of the type 'number'</returns>

    return typeof (o) == 'number';
}
window.isInt = function (o) {
    /// <summary>Determines if an object reference is an integer</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is an integer</returns>

    return Number(o) === o && o % 1 === 0;
}
window.isBool = function (o) {
    /// <summary>Determines if an object reference is of the type 'boolean'</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is of the type 'number'</returns>

    return typeof (o) == 'boolean';
}
window.isArray = function (o) {
    /// <summary>Determines if an object reference is of the type array</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is an array</returns>

    return o && $.isArray(o);
}
window.isDate = function (o) {
    /// <summary>Determines if an object reference is of the type 'date'</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is a date</returns>

    return $.type(o) == 'date';
}

window.isJQuery = function (o) {
    /// <summary>Determines if an object reference is a JQuery object</summary>
    /// <param name="o" type="Object">The object ref to test</param>
    /// <returns type="Boolean">True if the object is a JQuery objects</returns>

    return o instanceof jQuery;
}

window.isInIframe = function() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}

window.scrollBase = function () {
    /// <summary>Scrolls to the bottom of the page</summary>
    
    window.scrollTo(0, document.body.scrollHeight);
}

/// <summary>guid helper object</summary>
cafm.guid = {
    /// <field name='empty' type='String'>String representation of guid.empty</field>
    empty: '00000000-0000-0000-0000-000000000000',
    newGuid: function () {
        /// <summary>Returns a new GUID</summary>
        /// <returns type="String">The new GUID String</returns>
        return kendo.guid();
    }
}